var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.412 10.302a3.162 3.162 0 11-6.324 0 3.162 3.162 0 016.324 0z",
    stroke: "#D3DCE6",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.248 17.604c3.808 0 7.291-2.738 9.252-7.302C17.539 5.738 14.056 3 10.248 3h.004C6.444 3 2.961 5.738 1 10.302c1.961 4.564 5.444 7.302 9.252 7.302h-.004z",
    stroke: "#D3DCE6",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgEyeOn;